import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import isSafari from 'lib/web/isSafari'
import isChrome from 'lib/web/isChrome'
import {
  APPLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

export const isApplePayEnabled = (currency: string): boolean => !!(config.APPLE_PAY_ENABLED && getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) && !isChrome && isSafari)
